import { tr } from 'i18n';
import { getErpErrorMessage } from 'service/ErpService';
import { checkBranchesInRange, parseGeo } from './geo';

export class OperatorReceiptError extends Error {
  constructor(message, location = null) {
    super(message);
    this.name = 'OperatorReceiptError';
    this.location = location;
  }
}

export const unavailableOperatorLocation = () => tr('Не удалось определить местоположение оператора. Разрешите доступ к геолокации и повторите.');

// The load destination is authoritative. Never substitute the operator's other base.
export function checkOperatorReceiptLocation(geo, lastLoad) {
  if (!geo || typeof geo !== 'string' || !geo.trim()) {
    return { isInRange: false, reason: 'unavailable', message: unavailableOperatorLocation(), distanceInfo: '' };
  }
  if (!parseGeo(geo)) {
    return { isInRange: false, reason: 'invalid', message: tr('Некорректные координаты оператора. Обновите геолокацию и повторите.'), distanceInfo: '' };
  }
  const branches = Array.isArray(lastLoad?.geo_base) ? lastLoad.geo_base.filter(branch => parseGeo(branch?.geo)) : [];
  if (!branches.length) {
    return { isInRange: false, reason: 'configuration', message: tr('Не удалось проверить зону действия: у базы нет филиалов с корректными координатами. Обратитесь к администратору.'), distanceInfo: '' };
  }
  const result = checkBranchesInRange(geo, branches);
  return {
    ...result,
    reason: result.isInRange ? 'inside' : 'outside',
    message: result.isInRange
      ? tr('Местоположение подтверждено. Вы в пределах 200 метров от филиала.')
      : tr('Оператор вне зоны действия. Вы далеко от базы. Подойдите к филиалу на расстояние не более 200 метров.'),
  };
}

export function assertOperatorReceiptLocation(geo, lastLoad) {
  const location = checkOperatorReceiptLocation(geo, lastLoad);
  if (!location.isInRange) throw new OperatorReceiptError(location.message, location);
  return location;
}

export function getOperatorReceiptError(error) {
  return getErpErrorMessage(error, error instanceof OperatorReceiptError
    ? error.message
    : tr('Не удалось подтвердить прибытие. Попробуйте снова.'));
}
